import { render, staticRenderFns } from "./CreateWizard.vue?vue&type=template&id=1b4ac219"
import script from "./CreateWizard.vue?vue&type=script&lang=js"
export * from "./CreateWizard.vue?vue&type=script&lang=js"
import style0 from "./CreateWizard.vue?vue&type=style&index=0&id=1b4ac219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports